import React from "react";
import AdminLayout from "../components/layout/AdminLayout";
import UploadDocument from "../components/admin/UploadDocument";
import DocumentList from "../components/admin/DocumentList";
import SectionHeader from "../components/common/SectionHeader";
import { useNavigate } from "react-router-dom";

export default function DocumentsPage() {
  const navigate = useNavigate();

  const handleUploaded = (doc) => {
    if (!doc?.id) return;
    navigate(`/documents/${doc.id}`);
  };

  const handleOpenDocument = (doc) => {
    if (!doc?.id) return;
    navigate(`/documents/${doc.id}`);
  };

  return (
    <AdminLayout
      title="Documents"
      subtitle="Upload, search, filter, and open document workflows."
    >
      <div className="documents-hero">
        <div className="documents-hero-card">
          <div>
            <h2 className="documents-hero-title">Document Library</h2>
            <p className="documents-hero-subtitle">
              Manage your full document lifecycle from upload to signer
              workflow, progress tracking, audit review, and revision handling.
            </p>
          </div>
        </div>
      </div>

      <div className="dashboard-lower-grid">
        <div className="section-space">
          <SectionHeader
            title="Upload Document"
            subtitle=" Upload a new PDF, choose signing mode, and set when the request should expire."
            chips={["New Upload"]}
          />
          <UploadDocument onUploaded={handleUploaded} />
        </div>

        <div className="section-space">
          <SectionHeader
            title="Workspace Guide"
            subtitle="Recommended operational flow."
            chips={["How It Works"]}
          />

          <div className="card">
            <div className="activity-feed">
              <div className="activity-feed-item">
                <div className="activity-dot" />
                <div>
                  <div className="activity-title">Upload a PDF</div>
                  <div className="activity-text">
                    Start a new signing workflow by uploading a document and
                    setting expiry rules.
                  </div>
                </div>
              </div>

              <div className="activity-feed-item">
                <div className="activity-dot" />
                <div>
                  <div className="activity-title">Open Workspace</div>
                  <div className="activity-text">
                    Move into the document workspace to add signers, place
                    fields, and track progress.
                  </div>
                </div>
              </div>

              <div className="activity-feed-item">
                <div className="activity-dot" />
                <div>
                  <div className="activity-title">Remind Signers</div>
                  <div className="activity-text">
                    Send reminders to signers who haven't completed their action
                    to keep the workflow moving.
                  </div>
                </div>
              </div>

              <div className="activity-feed-item">
                <div className="activity-dot" />
                <div>
                  <div className="activity-title">Monitor Delivery</div>
                  <div className="activity-text">
                    Use analytics and audit history to monitor completion,
                    delays, and signer engagement.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card section-space">
            <h3 className="card-title">Quick Navigation</h3>
            <p className="card-subtitle">
              Jump directly into the other control areas.
            </p>

            <div className="inline-actions">
              <button
                className="btn btn-primary"
                onClick={() => navigate("/dashboard")}
              >
                Go to Dashboard
              </button>

              <button
                className="btn btn-primary"
                onClick={() => navigate("/analytics")}
              >
                Open Analytics
              </button>
            </div>
          </div> */}
        </div>
      </div>

      <div className="section-space">
        <SectionHeader
          title="Document Records"
          subtitle="Search and filter document records, then open the exact workspace you need."
          chips={["Library", "Searchable"]}
        />
        <DocumentList onOpenDocument={handleOpenDocument} />
      </div>
    </AdminLayout>
  );
}
